import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const deleteUserToken = (loginId) => {
  return apiRequestType(
    apiTypes.DELETE,
    apiConstants.LOGIN.DELETE_USER_TOKEN(loginId)
  );
};

export default deleteUserToken;